import React from 'react';
import styled from 'styled-components';
import radio_icon from './icons/select-box.svg';
import radio_active_icon from './icons/select-box-active.svg';
const noteOptions = [
  'Cash counted and confirmed',
  'Opening cash verified',
  'Closing cash counted',
  'Cash replenished mid-shift',
  'Cash removed by manager',
  'Cash variance resolved',
  'Adjustment approved by manager',
  'Counted with supervisor present',
  'Handed over to next staff',
  'Needs recount',
];

type Props = {
  value?: string;
  onChange?: (val: string) => void;
};
const CashDepositNote = ({ value, onChange }: Props) => {
  return (
    <Container>
      <Label>Note</Label>
      <div className="options-container">
        {noteOptions.map((option) => (
          <OptionItem key={option} label={option} value={value} onChange={onChange} />
        ))}
      </div>
      <div className="note-input-area">
        <span className="note-input-area-label">Add a note</span>
        <textarea placeholder='Please enter...' rows={3} value={value} onChange={e => onChange?.(e.target.value)} />
      </div>
    </Container>
  );
};

export default CashDepositNote;

const Label = styled.p`
  color: #505050;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const OptionItemContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: none;
  background: none;
  cursor: pointer;
  &:hover {
    background: #F6F7FC;
  }
  span {
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
type OptionItemProps = {
  label: string;
  value?: string;
  onChange?: (value: string) => void;
};

const OptionItem = ({ label, value, onChange }: OptionItemProps) => {
  return (
    <OptionItemContainer type='button' onClick={() => onChange?.(label)}>
      <img src={value === label ? radio_active_icon : radio_icon} alt="radio_icon" />
      <span>{label}</span>
    </OptionItemContainer>
  );
};

const Container = styled.div`
  display: flex;
  width: 413px;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  align-self: stretch;
  border-right: 1px solid #CCD4DC;
  background: #FFF;
  box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.15);

  .options-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
  }

  .note-input-area {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    align-self: stretch;
    .note-input-area-label {
      color: #1D2129;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    textarea {
      display: flex;
      height: 120px;
      padding: 7px 13px;
      flex-direction: column;
      align-items: flex-start;
      align-self: stretch;
      border-radius: 4px;
      border: 1px solid #86909C;
      background: #FFF;

      color: #1D2129;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;